/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import Image from '@tcp/core/src/components/common/atoms/Image';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import { toastMessageInfo } from '@tcp/core/src/components/common/atoms/Toast/container/Toast.actions';
import {
  getIsResetViaText,
  getIsResetPasswordAutoLoginEnabled,
  getLoginFlowUXEnhancement,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getEnableFullPageAuth } from '@tcp/web/src/components/features/content/HomePage/HomePage.selectors';
import { fetchPhone } from '@tcp/core/src/components/features/account/ResetPassword/container/ResetPassword.actions';
import { getViewportInfo, isClient, getIconPath } from '@tcp/core/src/utils';
import ResetPasswordSaga from '@tcp/core/src/components/features/account/ResetPassword/container/ResetPassword.saga';
import ResetPasswordReducer from '@tcp/core/src/components/features/account/ResetPassword/container/ResetPassword.reducer';
import { getContactFormValuesFromSS } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import { getSinglePageCheckoutSectionState } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { SPC_SECTION } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import {
  resetPassword,
  resetLoginForgotPasswordState,
  passResetOptionSelector,
  setIsShowOtpScreen,
  sendOTPError,
  getModuleXContent,
  saveUserEmailAddress,
  setResetPassEmail,
  resetPasswordSuccessFlag,
} from './ForgotPassword.actions';
import {
  getShowNotificationState,
  getResetEmailResponse,
  toggleSuccessfulEmailSection,
  getForgotPasswordErrorMessage,
  getIsFormSubmitting,
  getSelectedPassResetOption,
  getIsShowPhoneOption,
  getIsShowOTPScreen,
  getMaskedPhoneNumber,
  getAccountNotFoundError,
  getUserSavedEmail,
  getResetPasswordSuccessMsg,
  getEmailOnResetScreen,
  isResetPasswordSuccess,
} from './ForgotPassword.selectors';
import { resetUserInfo } from '../../User/container/User.actions';
import {
  closeOverlayModal,
  openOverlayModal,
} from '../../OverlayModal/container/OverlayModal.actions';
import {
  getLoginError,
  shouldShowRecaptcha,
  getExistingUserResponse,
  getCountryCode,
} from '../../LoginPage/container/LoginPage.selectors';
import { login } from '../../LoginPage/container/LoginPage.actions';
import { getUserLoggedInState } from '../../User/container/User.selectors';
import ForgotPasswordView from '../views/ForgotPassword.view';
import ForgotPasswordReducer from './ForgotPassword.reducer';
import { ForgotPasswordSaga } from './ForgotPassword.saga';
import {
  getDynamicLabelValues,
  renderLabel,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../utils/labels/labelUtilty';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '../../../../../utils/labels/globalActions.labels';

class ForgotPasswordContainer extends React.PureComponent {
  componentDidMount() {
    const { resetPasswordSuccessMsg, getAccountModuleXContent } = this.props;
    // check referred
    const referred = getDynamicLabelValues('dynamic.account_d.referred');
    if (!resetPasswordSuccessMsg && referred) {
      getAccountModuleXContent(referred);
    }
  }

  componentWillUnmount() {
    const { resetForm } = this.props;
    if (resetForm) resetForm();
  }

  getMaskedPhoneNumber = (string, n, find, repl) => {
    if (string.length < 1) {
      return '';
    }
    const stringWithDash = string.match(/.{1,3}/g).join('-');
    const stringWithTwoDash = stringWithDash.split(find);
    const maskedPhnNo =
      stringWithTwoDash.slice(0, n).join(find) + repl + stringWithTwoDash.slice(n).join(find);
    return `(${maskedPhnNo.slice(0, 3)})${maskedPhnNo.slice(3, 15)}`;
  };

  clickBackButton = () => {
    window.history.go(-1);
  };

  showBackButton = () => {
    const lefttarrow = getIconPath('toggle-left-arrow');
    const anchorStyle = { display: 'flex', alignItems: 'center', background: 'white' };
    return (
      <>
        <div className="back-button-otp-screen elem-pt-MED elem-pl-MED" style={anchorStyle}>
          <Image src={lefttarrow} onClick={this.clickBackButton} />
          <BodyCopy
            underline
            noLink
            fontFamily="secondary"
            fontSizeVariation="large"
            tag="span"
            fontSize="fs14"
            className="elem-ml-MED back-cta"
            onClick={this.clickBackButton}
          >
            {renderLabel(
              getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ACTIONS_LABELS}.lbl_back`,
                GlobalActionsLabels
              ),
              'lbl_back'
            )}
          </BodyCopy>
        </div>
      </>
    );
  };

  render() {
    const {
      resetForgotPasswordErrorResponse,
      resetForm,
      SubmitForgot,
      showNotification,
      successFullResetEmail,
      resetLoginState,
      showForgotPasswordForm,
      showLogin,
      forgotPasswordErrorMessage,
      toastMessage,
      updateHeader,
      onRequestClose,
      resetPasswordSuccessMsg,
      isFormSubmitting,
      fullPageView,
      openOverlay,
      setPassResetOption,
      selectedPassResetOption,
      isShowPhoneOption,
      isShowOTPScreen,
      toggleIsShowOtpScreen,
      maskedPhoneNumber,
      isAccountNotFoundError,
      resetSendOTPError,
      isResetViaText: isResetViaTextKey,
      userSavedEmail,
      plccEmail,
      fromOnBoarding,
      existingUserResponse,
      emailAddressFromSS,
      onSubmit,
      isResetPasswordAutoLoginEnabled,
      variation,
      phoneCountryCode,
      loginFlowUXEnhancementEnabled,
      className,
      ...otherProps
    } = this.props;
    const userEmailId =
      existingUserResponse?.emailAddress || emailAddressFromSS?.emailAddress || userSavedEmail;
    const initialValues = {
      rememberMe: true,
      savePlcc: true,
      Email: plccEmail || userSavedEmail || userEmailId,
    };
    const viewPortInfo = getViewportInfo();
    const { phoneCountryCode: phoneCountryCodeSS } = emailAddressFromSS || {};
    const isMobileView = viewPortInfo && isClient() && viewPortInfo.isMobile;
    const phoneCode = phoneCountryCode || phoneCountryCodeSS;
    const showSMSOption = phoneCode ? phoneCode === '+1' : true;
    const isResetViaText = !showSMSOption && isMobileView ? false : isResetViaTextKey;
    let resetOption = isResetViaText ? selectedPassResetOption : null;
    if (!selectedPassResetOption && isResetViaText) {
      resetOption = isMobileView ? 'sms' : null;
    }
    const updatedMaskedNumber =
      maskedPhoneNumber || existingUserResponse?.phoneNumber || emailAddressFromSS?.phoneNumber;
    const userMaskedPhoneNumber =
      updatedMaskedNumber && this.getMaskedPhoneNumber(updatedMaskedNumber, 3, '-', '');

    return (
      <div className={className}>
        {loginFlowUXEnhancementEnabled && this.showBackButton()}
        <div className="inner-container">
          <ForgotPasswordView
            onRequestClose={onRequestClose}
            showForgotPasswordForm={showForgotPasswordForm}
            resetPasswordSuccessMsg={resetPasswordSuccessMsg}
            initialValues={initialValues}
            resetForgotPasswordErrorResponse={resetForgotPasswordErrorResponse}
            resetForm={resetForm}
            SubmitForgot={SubmitForgot}
            showNotification={showNotification}
            successFullResetEmail={successFullResetEmail}
            resetLoginState={resetLoginState}
            showLogin={showLogin}
            forgotPasswordErrorMessage={forgotPasswordErrorMessage}
            toastMessage={toastMessage}
            updateHeader={updateHeader}
            isFormSubmitting={isFormSubmitting}
            fullPageView={fullPageView}
            openOverlay={openOverlay}
            setPassResetOption={setPassResetOption}
            selectedPassResetOption={resetOption}
            isShowPhoneOption={isShowPhoneOption}
            isShowOTPScreen={isShowOTPScreen}
            toggleIsShowOtpScreen={toggleIsShowOtpScreen}
            maskedPhoneNumber={userMaskedPhoneNumber}
            isAccountNotFoundError={isAccountNotFoundError}
            resetSendOTPError={resetSendOTPError}
            isResetViaText={isResetViaText}
            fromOnBoarding={fromOnBoarding}
            onSubmit={onSubmit}
            isResetPasswordAutoLoginEnabled={isResetPasswordAutoLoginEnabled}
            variation={variation}
            phoneCountryCode={phoneCountryCode || phoneCountryCodeSS}
            loginFlowUXEnhancementEnabled={loginFlowUXEnhancementEnabled}
            {...otherProps}
          />
        </div>
      </div>
    );
  }
}

ForgotPasswordContainer.propTypes = {
  resetLoginState: PropTypes.string,
  resetForgotPasswordErrorResponse: PropTypes.bool.isRequired,
  resetForm: PropTypes.bool.isRequired,
  SubmitForgot: PropTypes.bool.isRequired,
  showNotification: PropTypes.bool.isRequired,
  successFullResetEmail: PropTypes.bool.isRequired,
  showForgotPasswordForm: PropTypes.bool.isRequired,
  showLogin: PropTypes.func,
  forgotPasswordErrorMessage: PropTypes.shape({}).isRequired,
  toastMessage: PropTypes.string.isRequired,
  updateHeader: PropTypes.func,
  onRequestClose: PropTypes.func,
  resetPasswordSuccessMsg: PropTypes.string,
  getAccountModuleXContent: PropTypes.func,
  isFormSubmitting: PropTypes.bool.isRequired,
  fullPageView: PropTypes.bool,
  openOverlay: PropTypes.func,
  fullPageAuthEnabled: PropTypes.bool,
  setPassResetOption: PropTypes.func,
  selectedPassResetOption: PropTypes.string,
  isShowPhoneOption: PropTypes.bool,
  isShowOTPScreen: PropTypes.bool,
  toggleIsShowOtpScreen: PropTypes.func,
  maskedPhoneNumber: PropTypes.string,
  isAccountNotFoundError: PropTypes.bool,
};

ForgotPasswordContainer.defaultProps = {
  resetLoginState: () => {},
  showLogin: () => {},
  updateHeader: () => {},
  onRequestClose: () => {},
  resetPasswordSuccessMsg: '',
  getAccountModuleXContent: () => {},
  fullPageView: false,
  openOverlay: () => {},
  fullPageAuthEnabled: false,
  setPassResetOption: () => {},
  selectedPassResetOption: '',
  isShowPhoneOption: false,
  isShowOTPScreen: false,
  toggleIsShowOtpScreen: () => {},
  maskedPhoneNumber: '',
  isAccountNotFoundError: false,
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    resetLoginState: () => {
      dispatch(resetUserInfo());
    },
    SubmitForgot: (payload) => {
      dispatch(resetPassword(payload));
    },
    fetchPhoneActn: (payload) => {
      dispatch(fetchPhone(payload));
    },
    resetForm: (payload) => {
      dispatch(resetLoginForgotPasswordState(payload));
    },
    closeOverlay: () => {
      dispatch(closeOverlayModal());
    },
    openOverlay: (payload) => {
      dispatch(openOverlayModal(payload));
    },
    toastMessage: (palyoad) => {
      dispatch(toastMessageInfo(palyoad));
    },
    getAccountModuleXContent: (referred) => {
      dispatch(getModuleXContent(referred));
    },
    setPassResetOption: (payload) => {
      dispatch(passResetOptionSelector(payload));
    },
    toggleIsShowOtpScreen: (payload) => {
      dispatch(setIsShowOtpScreen(payload));
    },
    resetSendOTPError: (payload) => {
      dispatch(sendOTPError(payload));
    },
    resetPasswordAction: (payload) => {
      dispatch(resetPassword(payload));
    },
    resetPasswordSuccessFlag: (payload) => {
      dispatch(resetPasswordSuccessFlag(payload));
    },
    onSubmit: (payload) => {
      dispatch(saveUserEmailAddress(payload?.emailAddress));
      const { variation = '', fullPage = false, isRtpsFlow = false, componentType } = props;
      const modfiedPayload = {
        ...payload,
        mergeCart:
          !isRtpsFlow &&
          variation !== 'checkout' &&
          componentType !== 'loginV2' &&
          !payload.isResetFromCheckout,
        fullPage,
      };
      const fromForgotPassword = true;
      const afterLoginHandler = payload.afterLoginHandler || props.handleAfterLogin;
      dispatch(login(modfiedPayload, afterLoginHandler, fromForgotPassword));
    },
    saveResetEmail: (payload) => {
      dispatch(setResetPassEmail(payload));
    },
  };
};

const mapStateToProps = (state) => {
  const contactData = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);
  return {
    showNotification: getShowNotificationState(state),
    resetForgotPasswordErrorResponse: getResetEmailResponse(state),
    successFullResetEmail: toggleSuccessfulEmailSection(state),
    isUserLoggedIn: getUserLoggedInState(state),
    loginError: getLoginError(state),
    forgotPasswordErrorMessage: getForgotPasswordErrorMessage(state),
    showRecaptcha: shouldShowRecaptcha(state),
    resetPasswordSuccessMsg: getResetPasswordSuccessMsg(state),
    isFormSubmitting: getIsFormSubmitting(state),
    fullPageAuthEnabled: getEnableFullPageAuth(state),
    isResetViaText: getIsResetViaText(state),
    selectedPassResetOption: getSelectedPassResetOption(state),
    isShowPhoneOption: getIsShowPhoneOption(state),
    isShowOTPScreen: getIsShowOTPScreen(state),
    maskedPhoneNumber: getMaskedPhoneNumber(state),
    isAccountNotFoundError: getAccountNotFoundError(state),
    userSavedEmail: getUserSavedEmail(state),
    existingUserResponse: getExistingUserResponse(state),
    emailAddressFromSS: getContactFormValuesFromSS(contactData),
    isResetPasswordAutoLoginEnabled: getIsResetPasswordAutoLoginEnabled(state),
    emailOnResetScreen: getEmailOnResetScreen(state),
    isResetPasswordSuccess: isResetPasswordSuccess(state),
    phoneCountryCode: getCountryCode(state),
    loginFlowUXEnhancementEnabled: getLoginFlowUXEnhancement(state),
  };
};

const withReducer = withDynamicReducer([
  {
    key: 'ForgotPasswordReducer',
    reducer: ForgotPasswordReducer,
  },
  {
    key: 'ResetPassword',
    reducer: ResetPasswordReducer,
  },
]);
const withSaga = useDynamicSaga([
  { key: 'ForgotPasswordSaga', saga: ForgotPasswordSaga },
  { key: 'ResetPasswordSaga', saga: ResetPasswordSaga },
]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(ForgotPasswordContainer);
